import { Padding } from '@mui/icons-material';
import React, { useState, useEffect, useRef } from "react";
import Cheforder from '../Ordermanagment/Food/Cheforder';
import axios from 'axios';
import './Chefmanagement.css';
import MobileCheforders from '../Ordermanagment/Food/MobileCheforders';
import { Link } from 'react-router-dom';


const Chefmanagement = () => {
  const [orders, setOrders] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [vendorId, setVendorId] = useState(null);
  const isMobile = window.innerWidth <= 768;

  useEffect(() => {
    const storedVendorId = localStorage.getItem("vendorId");
    setVendorId(storedVendorId);
  }, []);

  useEffect(() => {
    if (!vendorId) return; // prevent running if vendorId is null

    const fetchOrders = async () => {
      const token = localStorage.getItem("authToken");
      if (!token) {
        console.warn("Auth token missing. Skipping order fetch.");
        return;
      }

      try {
        // 1️⃣ Fetch all orders from vendor
        const response = await axios.get(
          `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        const allVendorOrders = response.data || [];

        // Filter processing orders
        const processingOrders = response.data.filter(
          (order) => order.status === "PROCESSING"
        );

        // 2️⃣ Filter TABLE_DINE_IN orders from vendor with BEING_PREPARED items
        const confirmedOrdersFromVendor = allVendorOrders.filter(
          (order) =>
            order.orderType === "TABLE_DINE_IN" &&
            Array.isArray(order.cartItems) &&
            order.cartItems.some((item) => item.orderStatus === "BEING_PREPARED")
        );

        // 3️⃣ Fetch direct confirmed TABLE_DINE_IN orders via separate API
        const confirmedRes = await axios.get(
          `https://backend.maamaas.com/food/api/cart/get/ordertype=TABLE_DINE_IN/${vendorId}/BEING_PREPARED`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        const confirmedOrdersDirect = confirmedRes.data || [];

        // 🔥 Merge everything into one list
        const finalOrders = [
          ...processingOrders,
          ...confirmedOrdersFromVendor,
          ...confirmedOrdersDirect,
        ];

        setOrders(finalOrders);

      } catch (error) {
        console.error("Failed to fetch orders:", error.response?.data || error.message);
      }
    };

    fetchOrders(); // Initial fetch
    const intervalId = setInterval(fetchOrders, 1000); // Fetch every 1 second

    return () => clearInterval(intervalId); // Cleanup
  }, [vendorId]);









  const handleItemSelect = (orderId, index) => {
    setSelectedItems((prev) => {
      const existing = prev[orderId] || [];
      const updated = existing.includes(index)
        ? existing.filter((i) => i !== index)
        : [...existing, index];
      return { ...prev, [orderId]: updated };
    });
  };

  const handleSelectAll = (orderId, itemsLength) => {
    setSelectedItems((prev) => {
      const isAllSelected = prev[orderId]?.length === itemsLength;
      const newSelection = isAllSelected ? [] : [...Array(itemsLength).keys()];
      return { ...prev, [orderId]: newSelection };
    });
  };

  const [showDetails, setShowDetails] = useState(false);

  const orderStages = ["Preparing", "Prepared"];

  const styles = {
    card: { border: '1px solid #ccc', padding: '16px', margin: '16px', borderRadius: '10px', background: "linear-gradient(to right, #f46b45, #eea849)", },
    header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
    orderId: { margin: 0, fontWeight: "bold" },
    date: { fontSize: '18px', color: '#555', fontWeight: "bold" },
    pickupBtn: { background: '#28a745', color: '#fff', border: 'none', padding: '6px 12px', cursor: 'pointer', borderRadius: '5px', fontWeight: "bold", },
    tracker: { marginTop: '10px', display: 'flex', alignItems: 'center', fontWeight: "bold" },
    statusBox: { background: '#eee', padding: '8px 12px', borderRadius: '5px' },
    arrow: { margin: '0 5px' },
    dropdownBtn: { background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer', },
    itemList: { marginTop: '10px', fontWeight: "bold" },
    itemRow: { display: 'flex', justifyContent: 'space-between', padding: '4px 0', borderBottom: '1px solid #ddd' }
  };

  const handlePreparedClick = async (order) => {
    const token = localStorage.getItem("authToken"); // ✅ Get token from localStorage

    if (!token) {
      alert("Authorization token missing");
      return;
    }

    try {
      if (order.orderType === "TABLE_DINE_IN") {
        // 🔹 For TABLE_DINE_IN orders, update all cartItems to ORDER_IS_READY
        const status = "ORDER_IS_READY";
        const note = "Prepared successfully";

        const updatePromises = order.cartItems.map((item) =>
          axios.put(
            `https://backend.maamaas.com/food/api/cart/cartitem/status/${item.itemId}?status=${status}&note=${encodeURIComponent(note)}`,
            {},
            { headers: { Authorization: `Bearer ${token}` } }
          )
        );

        await Promise.all(updatePromises);
        console.log("✅ All dine-in items marked as ORDER_IS_READY");

        // 🔄 Update UI state
        setOrders((prev) =>
          prev.map((o) =>
            o.cartId === order.cartId
              ? {
                ...o,
                cartItems: o.cartItems.map((item) => ({
                  ...item,
                  orderStatus: status,
                })),
              }
              : o
          )
        );
      } else {
        // 🔹 For normal orders
        const response = await axios.put(
          `https://backend.maamaas.com/food/api/orders/edit-orders/${order.orderId}/ORDER_IS_READY`,
          { status: "ORDER_IS_READY" },
          { headers: { Authorization: `Bearer ${token}` } }
        );

        console.log("✅ Normal order marked as ORDER_IS_READY:", response.data);

        // 🔄 Update UI state
        setOrders((prev) =>
          prev.map((o) =>
            o.orderId === order.orderId ? { ...o, status: "ORDER_IS_READY" } : o
          )
        );
      }
    } catch (error) {
      console.error(
        "❌ Failed to update to ORDER_IS_READY:",
        error.response?.data || error.message
      );
    }
  };









  return (
    <div className="container-fluid mt-5">
      <div className="row">
        <div className="col-lg-2">
          <MobileCheforders />
        </div>
        <div className="col-lg-7 cartdta-mobilee" >

          <p
            className="breadcrumb maamaas-home-bredcum"
            style={{
              position: "fixed",
              top: isMobile ? "50px" : "80px",
              left: isMobile ? "5px" : "275px",
              width: "100%",
              backgroundColor: "#fff",
              zIndex: 1000,
              padding: "10px 0",
              fontSize: isMobile ? "14px" : "18px",
              fontWeight: isMobile ? "normal" : "bold",
              textAlign: "center",
              margin: 0,

            }}
          >
            {/* <Link
              to="/Newmainlandingpage"
              style={{
                color: "purple",
                fontWeight: "bold",
                textDecoration: "none",
              }}
            >
              Home
            </Link> */}
            <span className="separator"> &gt; </span>
            <Link
              // to="/company"
              style={{
                color: "purple",
                fontWeight: "bold",
                textDecoration: "none",
              }}
            >
              Food & Beverages
            </Link>
            <span className="separator"> &gt; </span>
            <Link

              style={{
                color: "purple",
                fontWeight: "bold",
                textDecoration: "none",
              }}
            >
              Chef_Managment
            </Link>

          </p>



          <div
            className="chef-managment"
            style={{ marginTop: isMobile ? "180px" : "150px" }}
          >
            <h2 style={{ marginBottom: '0px', marginTop: '-40px' }} className="text-center ">👨‍🍳 Chef Order Queue</h2>
          </div>
          <div style={{ overflow: "auto", height: "520px", scrollbarWidth: "none" }}>
            {orders.map((order) => {
              // Use cartItems for TABLE_DINE_IN, else use order.order
              const orderItems = order.orderType === "TABLE_DINE_IN" ? order.cartItems || [] : order.order || [];
              const orderId = order.orderId || order.cartId; // fallback for TABLE_DINE_IN
              const selected = selectedItems[orderId] || [];

              return (
                <div key={orderId} style={{ ...styles.card }}>
                  {/* Header */}
                  <div style={styles.header}>
                    <h3 style={styles.orderId}>Order ID: {orderId}</h3>
                    <button style={styles.pickupBtn} className="pickup-btn-data">
                      {order.orderService || order.orderType || "Service"}
                    </button>
                    <button
                      style={styles.dropdownBtn}
                      onClick={() =>
                        setShowDetails((prev) => ({
                          ...prev,
                          [orderId]: !prev[orderId],
                        }))
                      }
                    >
                      {showDetails[orderId] ? "▲" : "▼"}
                    </button>
                  </div>

                  {/* Order Details */}
                  {showDetails[orderId] && (
                    <>
                      {/* Date & Time */}
                      <p style={styles.date}>
                        {order.orderDateAndTime ? (() => {
                          const dateObj = new Date(order.orderDateAndTime);
                          const date = dateObj.toLocaleDateString("en-IN", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                          });
                          const time = dateObj.toLocaleTimeString("en-IN", {
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                          });
                          return (
                            <>
                              <span style={{ color: "black" }}>Date: </span>
                              <span style={{ color: "white" }}>{date}</span>
                              <br />
                              <span style={{ color: "black" }}>Time: </span>
                              <span style={{ color: "white" }}>{time}</span>
                            </>
                          );
                        })() : "N/A"}
                      </p>

                      {/* Order Table */}
                      {orderItems.length > 0 && (
                        <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "1rem" }}>
                          <thead>
                            <tr style={{ backgroundColor: "#b15cd6", textAlign: "center" }}>
                              <th style={{ padding: "8px", border: "1px solid #ddd" }}>
                                <input
                                  type="checkbox"
                                  checked={selected.length === orderItems.length}
                                  onChange={() => handleSelectAll(orderId, orderItems.length)}
                                />
                              </th>
                              <th style={{ padding: "8px", border: "1px solid #ddd" }}>S.No</th>
                              <th style={{ padding: "8px", border: "1px solid #ddd" }}>Item Name</th>
                              <th style={{ padding: "8px", border: "1px solid #ddd" }}>Quantity</th>
                            </tr>
                          </thead>
                          <tbody>
                            {orderItems.map((item, index) =>
                              // Show only Okay items or TABLE_DINE_IN items
                              item.status === "Okay" || order.orderType === "TABLE_DINE_IN" ? (
                                <tr
                                  key={index}
                                  style={{
                                    borderBottom: "1px solid #eee",
                                    fontWeight: "bold",
                                    backgroundColor: "#d4edda",
                                  }}
                                >
                                  <td
                                    style={{
                                      padding: "8px",
                                      border: "1px solid #ddd",
                                      textAlign: "center",
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      checked={selected.includes(index)}
                                      onChange={() => handleItemSelect(orderId, index)}
                                    />
                                  </td>
                                  <td style={{ padding: "8px", border: "1px solid #ddd" }}>{index + 1}</td>
                                  <td style={{ padding: "8px", border: "1px solid #ddd" }}>{item.dishName}</td>
                                  <td style={{ padding: "8px", border: "1px solid #ddd" }}>{item.quantity || 1}</td>
                                </tr>
                              ) : null
                            )}
                          </tbody>
                        </table>
                      )}
                    </>
                  )}

                  {/* Order Stages Tracker */}
                  <div
                    style={{
                      ...styles.tracker,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {Array.isArray(orderStages) &&
                      orderStages.map((stage, index) => {
                        let isActive = false;
                        let isClickable = false;

                        // Normal orders
                        if (
                          order.orderType !== "TABLE_DINE_IN" &&
                          ((order.status === "PROCESSING" && stage === "Preparing") ||
                            (order.status === "ORDER_IS_READY" && stage === "Prepared"))
                        ) {
                          isActive = true;
                          isClickable = stage === "Prepared" && order.status === "PROCESSING";
                        }

                        // TABLE_DINE_IN orders
                        if (order.orderType === "TABLE_DINE_IN" && Array.isArray(order.cartItems)) {
                          if (
                            stage === "Preparing" &&
                            order.cartItems.some((item) => item.orderStatus === "BEING_PREPARED")
                          ) {
                            isActive = true;
                          }
                          if (stage === "Prepared" && order.cartItems.some((item) => item.orderStatus === "ORDER_IS_READY")) {
                            isActive = true;
                            isClickable = true;
                          }
                        }

                        return (
                          <React.Fragment key={index}>
                            <div
                              onClick={() => {
                                if (stage === "Prepared") {
                                  handlePreparedClick(order);
                                }
                              }}
                              style={{
                                ...styles.statusBox,
                                backgroundColor: isActive ? "green" : "#f0f0f0",
                                color: isActive ? "white" : "black",
                                borderRadius: "6px",
                                padding: "8px 12px",
                                fontWeight: "bold",
                                textTransform: "uppercase",
                                cursor: isClickable ? "pointer" : "default",
                              }}
                            >
                              {stage}
                            </div>
                            {index !== orderStages.length - 1 && <span style={styles.arrow}></span>}
                          </React.Fragment>
                        );
                      })}
                  </div>


                </div>
              );
            })}

          </div>

        </div>
        <div className="col-lg-3">
          <Cheforder />
        </div>
      </div>
    </div>
  );
};

export default Chefmanagement;
